export const EMAIL = "email";
export const ALLOWS_MARKETING = "allowsMarketing";
export const OVER_18 = "over18";

function pad(value) {
  return value < 10 ? "0" + value : value;
}

function getUtcOffset() {
  const date = new Date();
  const sign = date.getTimezoneOffset() > 0 ? "-" : "+";
  const offset = Math.abs(date.getTimezoneOffset());
  const hours = pad(Math.floor(offset / 60));
  const minutes = pad(offset % 60);
  return sign + hours + ":" + minutes;
}

export const BLANK_CONTACT = {
  [EMAIL]: null,
  [ALLOWS_MARKETING]: false,
  [OVER_18]: false,
  utcOffset: getUtcOffset(),
  market: window.ww.locale
};
